/* Code copyright 2019 (c) Tuva Labs Inc. */
/**
 * created by Naveenkumar Ganesan
 *
 * For input/display of Filter Range Min/Max of the Attribute Settings Card
 * Handles date types Numeric and numeric subtypes "duration", "durationHM", "extractedNumber", "fraction", "year"
 * See also DurationInputComponent (.js) which is Min/Max of Axis Range of the Plot Settings Card
 * Consider consolidating these two components of the same name
 */

import React from 'react';

class DurationInputComponent extends React.Component {

  state = {}

  onChange = ( e ) => {
    let Dyn = this.props.Dyn,
        value = e.target.value;
    this.internalUpdate = true;
    this.setState({
      value: value
    });

    // check the string, converting to a numeric value
    //  e.g. "00:12" => 12, "1/2" => 0.5 for Dyn.dataUtil.subtypes.kDurationHMS, kFraction
    const attr = this.props.attributeObj;
    let dataFormat = {},
        numericValue = attr.axisInputToAxisValue( value, dataFormat ),
        isAcceptable = !Dyn.dataUtil.isMissing( numericValue )
          && (value !== "") && (value.substring(value.length-1) != ".");
    //console.log("isAcceptable", isAcceptable, value, "->", numericValue );

    if( isAcceptable ) {
      this.delayParentChange( numericValue );
    } else {
      // Cancel input change pass to parent when invalid characters are typed
      clearTimeout(this.inputChangeTimeout);
      this.inputChangeTimeout = null;
    }
  }

  delayParentChange (value) {
    if(this.inputChangeTimeout) {
      clearTimeout(this.inputChangeTimeout);
      this.inputChangeTimeout = null;
    }
    this.inputChangeTimeout = setTimeout(function(){
      this.inputChangeTimeout = null;
      this.props.onChange(value);
    }.bind(this), 700);
  }

  onBlur = ( e ) => {
    if(this.inputChangeTimeout) {
      return;
    }
    // Reset value
    this.internalUpdate = true;
    this.setState({
      value: this._getFormattedValue(this.props.value)
    });
  }

  _getFormattedValue (value) {
    let Dyn = this.props.Dyn;
    // console.log( "Filter DurationInputComponent._getFormattedValue()", this.props.attributeObj.subType, value, this.props.attributeObj.axisValueToString(value, Dyn.mathUtil.decimalPlaces(value)));
    return this.props.attributeObj.axisValueToString(value, Dyn.mathUtil.decimalPlaces(value));
  }

  render = () => {
    if(!this.internalUpdate) {
      this.state.value = this._getFormattedValue(this.props.value);
    } else {
      this.internalUpdate = false;
    }
    return (
      <input type="text" className={this.props.className}
        aria-label={this.props.arialabel}
        onChange={this.onChange}
        onBlur={this.onBlur}
        value={this.state.value} />
    );
  }
}

export default DurationInputComponent
